import React from 'react';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import TradelineCreditCardsModuleView from 'partial/OfferManager/modules/TradelineCreditCardsModule/TradelineCreditCardsModuleView';
import { useSelector } from 'react-redux';
import { GRADES_FOR_DEBT_PAYOFF_MODULE } from 'pages/RedesignDashboard/constants';

const TradelineCreditCardsModuleController = props => {
  const { additionalData, userInfo, history } = props;
  const { selectedBureau, profileContainer, creditReports } = useSelector(
    state => ({
      selectedBureau: state?.score1b3bFactorDial?.bureau?.selectedBureau,
      profileContainer: state?.profileContainer?.profileContainer,
      creditReports: state?.creditReport?.creditReports,
    }),
  );
  const loading = props.globalLoadingFlag;
  const gradesForDebtPayOffModule = [
    GRADES_FOR_DEBT_PAYOFF_MODULE.B,
    GRADES_FOR_DEBT_PAYOFF_MODULE.C,
    GRADES_FOR_DEBT_PAYOFF_MODULE.D,
    GRADES_FOR_DEBT_PAYOFF_MODULE.F,
  ];
  const showCreditDebtPayOff = gradesForDebtPayOffModule.includes(
    props?.creditInfo?.creditScoreAnalysis?.paymentHistory?.grade,
  );

  const tradelines = additionalData?.tradeLines;
  if (loading && tradelines) {
    return <PageLoadingMask description={'Loading...'} />;
  } else {
    return (
      <TradelineCreditCardsModuleView
        tradelines={tradelines}
        userInfo={userInfo}
        creditReports={creditReports}
        selectedBureau={selectedBureau}
        profileContainer={profileContainer}
        showCreditDebtPayOff={showCreditDebtPayOff}
        history={history}
      />
    );
  }
};

export default TradelineCreditCardsModuleController;
